import AdminTabs from '../components/Tabs';
import { Typography, Card } from '@mui/material';
import { useQuestionsContext } from '../../../context/QuestionsContext';

export default function Admin({ user }) {
    const questions = useQuestionsContext();
    console.log('Questions:', questions); // Note: The multiple logs are normal. They're caysed by context state updates, nested re-renders, and React 18 Strict Mode dev behavior. Using useEffect for logging can help reduce console spam.

    return (
        <>
            <Card
                variant='outlined'
                sx={{
                    p: { xs: 1.5, sm: 4 },
                    mt: { xs: 1.5, sm: 4 },
                    mb: { xs: 1.5, sm: 4 },
                }}
            >
                <Card>
                    <Typography
                        variant='h5'
                        gutterBottom
                    >
                        Admin Dashboard
                    </Typography>
                    <Typography variant='body1'>
                        Manage users and quiz questions from
                        this panel.
                    </Typography>
                </Card>
                <Card
                    variant='outlined'
                    sx={{ p: { xs: 1.5, sm: 4 }, mt: { xs: 1.5, sm: 4 } }}
                >
                    <AdminTabs user={user} />
                </Card>
            </Card>
        </>
    );
}